import { render, staticRenderFns } from "./previewEdit.vue?vue&type=template&id=2330166e&scoped=true"
import script from "./previewEdit.vue?vue&type=script&lang=js"
export * from "./previewEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330166e",
  null
  
)

export default component.exports